/**
 * @generated SignedSource<<eec1f7b16d2ccd0e2adccc4ce177f285>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type BulkImportExtProjectListInput = {
  extProjectIdList: ReadonlyArray<number>;
  integrationId: number;
};
export type ProjectBulkImportExtProjectListMutation$variables = {
  input: BulkImportExtProjectListInput;
};
export type ProjectBulkImportExtProjectListMutation$data = {
  readonly bulkImportExtProjectList: {
    readonly account: {
      readonly id: number;
    } | null | undefined;
  };
};
export type ProjectBulkImportExtProjectListMutation = {
  response: ProjectBulkImportExtProjectListMutation$data;
  variables: ProjectBulkImportExtProjectListMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "BulkImportExtProjectListOutput",
    "kind": "LinkedField",
    "name": "bulkImportExtProjectList",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "accounts",
        "kind": "LinkedField",
        "name": "account",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProjectBulkImportExtProjectListMutation",
    "selections": (v1/*: any*/),
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProjectBulkImportExtProjectListMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a34d881579309ba3afdafde9a800b911",
    "id": null,
    "metadata": {},
    "name": "ProjectBulkImportExtProjectListMutation",
    "operationKind": "mutation",
    "text": "mutation ProjectBulkImportExtProjectListMutation(\n  $input: BulkImportExtProjectListInput!\n) {\n  bulkImportExtProjectList(input: $input) {\n    account {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "bcdd05688b4c506f5a8fa9851e7abf86";

export default node;
